<template>
<div class="search-filters">

    <div class="head">
        <span>{{$t('search_filters_filter')}}</span>
        <div class="reset" v-if="filters.length > 0 && !noResults" @click='clearFilters()'>
            <span>{{$t('search_filters_reset')}}</span>
        </div>

        <div class="expand" :class="{open: filtersOpen}">
            <img src="@/assets/svg/caret.svg" alt="" @click="toggleFilterList">
        </div> 
    </div>


    <!-- Meta stuff, like loading indicator and reset button when no results -->
    <div class="info" v-if="$store.state.search.loading === 'data'">
        <font-awesome-icon class="spinner" icon="spinner" spin></font-awesome-icon>
    </div>

    <div class="info" v-if="noResults && $store.state.search.loading !== 'data' && !$store.state.search.loadingSearch">
        No results found with search term <strong>{{ this.$store.state.search.searchedQuery }}</strong>.<br>
        <button @click='resetForm()' class="reset-button btn btn-primary">
            Reset form
        </button>
    </div>
    

    <div v-if="$store.state.search.loading !== 'data' && showTypeFilter" 
            class="top-filters" :class="{open: filtersOpen}">

        <div v-if="typeFilter.length > 0" class="single-filter">
            <div class="filter">
                <div class="filter-name" id="filter-name-type" @click="toggleFilter('type')" 
                        :class="{ 'open': currentOpenFilters.includes('type'), 'active': hasActiveFilter('type') }">
                    <span>{{$t('search_filter_product_type')}}</span>
                </div>

                <div class="filter-values" v-if="currentOpenFilters.includes('type')">
                    <div class="custom-control custom-radio" v-for="(item, index) in typeFilter" :key="index">
                        <input type="radio" class="custom-control-input" name="product-type-radio" :value="item.value" :id="item.value" @change="setFilter(item.value, 'type')" :checked="item.selected" />
                        <label class="custom-control-label font-resp" :for="item.value">{{ $t(item.value) }}</label>
                    </div>
                </div>
            </div>
        </div>

    </div>


    <div v-if="$store.state.search.loading !== 'data' &&
                (!showTypeFilter || filters.length > 0)"
            class="all-filters" 
            v-show="$store.state.search.loading !== 'type'" 
            :class="{open: filtersOpen}">

        <div class="filter-selector" v-for="(facet, key) in $store.state.search.filterList" :key="key">
            <div class="filter">
                <!-- Filter header -->
                <div class="filter-name" :id="`filter-name-${facet.name}`" @click="toggleFilter(facet.name)" :class="{ 'open': currentOpenFilters.includes(facet.name), 'active': hasActiveFilter(facet.name) }">
                    <span>
                        {{ $t(facet.name) }}
                    </span>
                </div>

                <!-- Filter values -->
                <div class="filter-values" v-if="currentOpenFilters.includes(facet.name)">
                    <div class="custom-control custom-checkbox" v-for="(item, index) in facet.values" :key="index">
                        <input type="checkbox" class="custom-control-input" :id="item.value" @click="setFilter(item.value, facet.name)" :checked="item.selected" />
                        <label class="custom-control-label font-resp" :for="item.value">{{ addUnits(facet.name, item.value) }}</label>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    
</div>
</template>



<script>
    import { addUnits, colorCri } from '@/services/utils';

    export default {
        name: "SearchFilters",
        components: {},

        data() {
            return {
                filtersOpen: false,
                currentOpenFilters: [],
                searchedString: '',
            };
        },

        mounted() {
            this.currentOpenFilters.push(this.$store.state.ui.defaultOpenFilter);
        },

        computed: {
            typeFilter() {
                let facetsList = this.$store.state.search.facets;
                if ("type" in facetsList)
                    return facetsList["type"];
                return [];
            },

            showTypeFilter() {
                let show = false;
                for (let f of this.filters)
                    if ("type" in f)
                    {
                        show = true;
                        break;
                    }
                return this.typeFilter.length > 1 || show;
            },

            filters() {
                return this.$store.state.search.filters;
            },

            results() {
                this.$store.state.search.loading = '';
                return this.$store.state.search.searchResults;
            },

            noResults() {
                const searchStore = this.$store.state.search;
                const facetsArray = Object.keys(searchStore.facets);
                const emptyFacets = facetsArray.filter(facet => searchStore.facets[facet].length === 0);
                if (searchStore.searchQuery !== "" || emptyFacets.length === facetsArray.length) {
                    return emptyFacets.length === facetsArray.length;
                } else {
                    return false;
                }
            }
        },

        

        methods: {
            addUnits(facet, value) {
                let units = addUnits(this.$store.state.search.unitDictionary, facet, value);
                if (facet == "color") {
                  units += " " + colorCri(value);
                }
                return units;
            },

            toggleFilterList() {
                this.filtersOpen = !this.filtersOpen;
            },

            toggleFilter(filterName) {
                if (this.currentOpenFilters.includes(filterName)) {
                    this.currentOpenFilters = this.currentOpenFilters.filter(item => item !== filterName);
                } else {
                    this.currentOpenFilters.push(filterName);
                }
            },

            setFilter(item, filter) {
                this.$store.state.search.loading = filter;
                let exist = false;
                let checked = "unchecked";
                let filters = [...this.filters];

                // Check if filter already exists
                for (let filterObject of filters) {
                    // Look for the right filter group
                    if (filterObject[filter] == null)
                        continue;

                    // The "type" filter is the only one that should be a radio instead of a checkbox.
                    if(filter === "type") {
                        filterObject.type = [item];
                        exist = true;
                    }
                    else {
                        const index = filterObject[filter].indexOf(item);
                        if(index === -1) {
                            filterObject[filter].push(item);
                            exist = true;
                            checked = "checked";
                        } else {
                            filterObject[filter].splice(index, 1);
                            exist = true;
                        }
                    }
                }

                // If filter doesn't exist, add new filter
                if (!exist) {
                    const filterObject = {};
                    filterObject[filter] = [item];
                    filters.push(filterObject);
                }

                // Remove filters with no values
                filters = filters.filter(filterObject => {
                    let key = Object.keys(filterObject)[0];
                    return filterObject[key].length > 0;
                });

                this.$store.commit('search/filters', filters);

                //Radio button value is always checked
                if(filter === 'type'){
                    checked = "checked";
                }
                //If filter is a radio button check if filter already exists
                else if(!exist){

                    //filter doesn't exists, which means it's now checked
                    checked = 'checked';
                }
                try {
                    omniture.trackFilterWithActiveFilters(filter, item, checked, filters);
                } catch (e) {}

                this.$store.dispatch('search/search');
            },

            clearFilters() {
                this.$store.dispatch("search/clearFilters");
            },

            hasActiveFilter(filter) {
                for (let f of this.filters) {
                    const key = Object.keys(f)[0];
                    if (key === filter)
                        return true;
                }
                return false;
            },

            resetForm() {
                this.$store.state.search.loading = 'reset';
                this.$store.commit('search/searchQuery', "");
                this.getFacets();
            },

            getFacets() {
                this.$store.dispatch('search/getFacets');
            }
        },
    };
</script>



<style lang="scss">

    .spinner {
        color: $blue;
        margin-right: 0.5rem;
    }

    .reset-spinner {
        color: $white;
    }

    .reset-button {
        margin-top: 1em;
        padding: 0.26rem 1rem .2rem;
        font-size: 11px;
        font-weight: 400;
    }

    .search-filters {
        padding: 16px 19px 20px 19px;
        border: $nc-gray-border;
        background-color: $nc-gray-bg;

        .head {
            position: relative;
            margin-bottom: 35px;
            @include media-breakpoint-down(sm) {
                margin-bottom: 0;
            }

            > span {
                font-size: $nc-fsz-xl;
                font-weight: 600;
            }

            > .reset {
                display: block;
                text-align: right;
                font-size: $nc-fsz-s;
                color: $nc-blue-primary;
                position: absolute;
                bottom: 0.2em;
                right: 0;

                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }
        }


        .info {
            margin-top: 20px;
            text-align: center;
        }


        .expand {
            text-align: center;
            position: absolute;
            width: 100%;
            top: 0px;
            pointer-events: none;

            @include media-breakpoint-up(md) {
                display: none;
            }

            >img {
                pointer-events: all;
                width: 30px;
                height: 30px;
                cursor: pointer;
            }

            &.open >img {
                transform: rotate(180deg);
            }
        }


        .top-filters, .all-filters {
            @include media-breakpoint-down(sm) {
                display: none;

                &.open {
                    display: block;
                }
            }
        }

        .filter {
            position: relative;
            margin-top: 15px;
            font-size: $nc-fsz-normal;

            .filter-name {
                font-weight: bold;
                display: inline-block;
                width: 100%;
                color: $dark-gray;
                font-size: $nc-fsz-normal;
                position: relative;


                &:after {
                    content: "";
                    $size: 12px;
                    position: absolute;
                    right: 0;
                    top: 0.5em;
                    display: block;
                    background: url('../assets/svg/caret.svg') no-repeat;
                    width: $size;
                    height: $size;
                }

                
                &:hover {
                    cursor: pointer; /* Todo Replace */
                }

                &.open:after {
                    transform: rotate(180deg);
                    top: 0.2em;
                }
            }

            .filter-values {
                padding-top: 10px;

                

                .custom-control {
                    min-height: auto;
                    padding-left: 1.7rem;
                }

                .custom-checkbox {
                    margin-bottom: 8px;
                    font-size: $tiny-font-size;

                    input,
                    label {
                        cursor: pointer;
                    }

                    .custom-control-label::before,
                    .custom-control-label::after{
                        width: 1.2rem;
                        height: 1.2rem;
                        left: -1.6rem;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }

                .custom-radio {
                    margin-bottom: 8px;
                    font-size: $tiny-font-size;

                    input,
                    label {
                        cursor: pointer;
                        text-transform: capitalize;
                    }

                    .custom-control-label::before,
                    .custom-control-label::after{
                        width: 1.2rem;
                        height: 1.2rem;
                        left: -1.6rem;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }

        

        .show-all-filters {
            color: $dark-gray;
            font-size: $tiny-font-size;

            &:hover {
                color: lighten($dark-gray, 10%);
                cursor: pointer;
            }
        }
        .clear-filter-container {
            position: relative;
            display: inline-block;

            .clear-filters {
                width: auto;
                display: inline-block;
                min-width: 95px;
                color: $dark-gray;
                margin: 0 0.25rem 0.25rem 0;
                padding: 0.5rem 1.8rem 0.3rem 0.8rem;
                font-size: $tiny-font-size;

                &:after {
                    $size: 22px;
                    position: absolute;
                    right: 7px;
                    top: 5px;
                    display: block;
                    content: "";
                    background: url('../assets/svg/close.svg') no-repeat;
                    width: $size;
                    height: $size;
                }

                &:hover {
                    color: lighten($dark-gray, 10%);
                    cursor: pointer;
                }
            }
        }
    }
</style>
